let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5dEHm")).then(() => parcelRequire('9rH46'));